var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSync = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.736 12.48a5.25 5.25 0 0 1-6.41-.73h1.173a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0v-1.205a6.75 6.75 0 0 0 11.14-2.617.75.75 0 1 0-1.42-.484 5.25 5.25 0 0 1-2.233 2.787zM5.265 3.52a5.25 5.25 0 0 1 6.41.73h-1.174a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 .75-.75V2a.75.75 0 0 0-1.5 0v1.205A6.75 6.75 0 0 0 1.612 5.822a.75.75 0 1 0 1.42.484 5.25 5.25 0 0 1 2.233-2.787z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSync);
export default ForwardRef;